import { BaseResponse } from "../models/BaseResponse";
import { SecurityQuestionsResponse } from "../models/SecurityQuestionsResponse";
import { AuthUserLoginRequest } from "../models/AuthUserLoginRequest";
import { AuthUserLoginResponse } from "../models/AuthUserLoginResponse";
import { AuthUserPasswordResetRequest } from "../models/AuthUserPasswordResetRequest";
import { AuthUserPasswordResetResponse } from "../models/AuthUserPasswordResetResponse";
import { AuthUserRegistrationRequest } from "../models/AuthUserRegistrationRequest";
import { AuthUserResetPasswordRequest } from "../models/AuthUserResetPasswordRequest";
import { AuthUserResetPasswordResponse } from "../models/AuthUserResetPasswordResponse";
import { AuthUserValidateAwnserResponse } from "../models/AuthUserValidateAwnserResponse";
import { AuthUserValidateIdentityRequest } from "../models/AuthUserValidateIdentityRequest";
import { AuthUserValidateResponse } from "../models/AuthUserValidateResponse";
import { APIService } from "./APIService";
import { AuthUserVerifyEmailRequest } from "../models/AuthUserVerifyEmailRequest";
import { AuthUserVerifyEmailResponse } from "../models/AuthUserVerifyEmailResponse";
import { AuthUserValidateMFARequest } from "../models/AuthUserValidateMFARequest";
import { AuthUserResendMFARequest } from "../models/AuthUserResendMFARequest";
import { AuthUserResendMFAResponse } from "../models/AuthUserResendMFAResponse";
import { AuthUserLogoutResponse } from "../models/AuthUserLogoutResponse";
import moment from "moment";

export class AuthAPIService {
    private _apiService: APIService;

    constructor(){
        this._apiService = new APIService();
    }

    public async validateIdentity(userValidateIdentityRequest: AuthUserValidateIdentityRequest): Promise<BaseResponse<AuthUserValidateResponse>> {
        if(userValidateIdentityRequest.dob){
            userValidateIdentityRequest.dob = moment(userValidateIdentityRequest.dob).format("YYYY-MM-DD");
        }
        return this._apiService.sendRequest<BaseResponse<AuthUserValidateResponse>, AuthUserValidateIdentityRequest>("Auth/Validate", "POST", userValidateIdentityRequest);
    }

    public async getSecurityQuestions():Promise<BaseResponse<SecurityQuestionsResponse>>{
        return this._apiService.sendRequest<BaseResponse<SecurityQuestionsResponse>,undefined>("Auth/GetSecurityQuestions", "GET");
    }

    public async registerUser(userRegistrationRequest: AuthUserRegistrationRequest): Promise<BaseResponse<boolean>>{
        return this._apiService.sendRequest<BaseResponse<boolean>, AuthUserRegistrationRequest>("Auth/Register","POST", userRegistrationRequest);
    }

    public async login(loginRequest: AuthUserLoginRequest):Promise<BaseResponse<AuthUserLoginResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserLoginResponse>,AuthUserLoginRequest>("Auth/Login","POST",loginRequest);
    }

    public async logout(token: string):Promise<BaseResponse<AuthUserLogoutResponse>> {
        return this._apiService.sendRequest<BaseResponse<AuthUserLogoutResponse>, undefined>("Auth/Logout", "POST", undefined, token);
    }

    public async refreshToken(token: string): Promise<BaseResponse<AuthUserLoginResponse>> {
        return this._apiService.sendRequest<BaseResponse<AuthUserLoginResponse>, undefined>("Auth/RefreshToken", "POST", undefined, token);
    }

    public async validateMFA(request: AuthUserValidateMFARequest): Promise<BaseResponse<AuthUserLoginResponse>> {
        return this._apiService.sendRequest<BaseResponse<AuthUserLoginResponse>,AuthUserValidateMFARequest>("Auth/ValidateUserMFA", "POST", request);
    }

    public async resendMFA(request: AuthUserResendMFARequest): Promise<BaseResponse<AuthUserResendMFAResponse>> {
        return this._apiService.sendRequest<BaseResponse<AuthUserResendMFAResponse>, AuthUserResendMFARequest>("Auth/ResendMFACode", "POST", request);
    }

    public async requestPasswordReset(passwordResetRequest: AuthUserPasswordResetRequest):Promise<BaseResponse<AuthUserPasswordResetResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserPasswordResetResponse>, AuthUserPasswordResetRequest>("Auth/RequestPasswordReset", "POST", passwordResetRequest);
    }
   
    public async validateAwnser(validateAwnserRequest: AuthUserPasswordResetRequest):Promise<BaseResponse<AuthUserValidateAwnserResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserValidateAwnserResponse>, AuthUserPasswordResetRequest>("Auth/ValidateAnswers", "POST", validateAwnserRequest);
    }

    public async resetPassword(resetPasswordRequest: AuthUserResetPasswordRequest): Promise<BaseResponse<AuthUserResetPasswordResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserResetPasswordResponse>, AuthUserResetPasswordRequest>("Auth/ResetPassword", "POST", resetPasswordRequest);
    }

    public async veryEmail(verifyRequest: AuthUserVerifyEmailRequest): Promise<BaseResponse<AuthUserVerifyEmailResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserVerifyEmailResponse>, AuthUserVerifyEmailRequest>("Auth/VerifyEmail", "POST", verifyRequest);
    }
}